/**
 * 걸음수 화면 공용 유틸 (날짜 포맷 + 파생 수치)
 */

/**
 * "2026-08-06" — 삼성 헬스 SDK 에 넘기는 날짜 형식.
 *
 * ⚠ toISOString() 을 쓰면 안 된다. UTC 기준이라 KST 오전 9시 이전이면 하루가 밀려서
 *   "오늘 걸음수" 자리에 어제 값이 뜬다. 반드시 로컬 타임존 기준으로 조립할 것.
 */
export const toLocalDateStr = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
};

/** n일 전 Date (0 = 오늘) */
export const daysAgo = (n) => {
    const d = new Date();
    d.setDate(d.getDate() - n);
    return d;
};

const DAY_NAMES = ['일', '월', '화', '수', '목', '금', '토'];

/** "2026.08.06(수)" — 대시보드 상단 표기 */
export const formatDisplayDate = (dateStr) => {
    const d = new Date(`${dateStr}T00:00:00`);
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}.${m}.${day}(${DAY_NAMES[d.getDay()]})`;
};

/** "8.6" — 막대그래프 x축 라벨 */
export const formatShortDate = (dateStr) => {
    const [, m, d] = dateStr.split('-');
    return `${Number(m)}.${Number(d)}`;
};

/** "26.08.06" — 전체 기록 리스트 표기 */
export const formatRecordDate = (dateStr) => {
    const [y, m, d] = dateStr.split('-');
    return `${y.slice(2)}.${m}.${d}`;
};

/**
 * 소모 칼로리 / 걸은 거리.
 *
 * 삼성 헬스의 걸음수 집계는 **걸음 수만** 준다 — 칼로리·거리는 별도 데이터(활동 요약)라
 * 권한을 더 받아야 하고, 그 값은 자전거 등 걷기 외 활동까지 포함한다.
 * 그래서 화면·서버 값은 걸음수 기반 추정치다. 계수는 기존 화면이 쓰던 값을 유지했다
 * (0.04 kcal/걸음, 0.8 m/걸음 ≈ 성인 평균 보폭).
 *
 * ⚠ 거리는 소수점 1자리다 — DB 컬럼이 numeric(5,1) 이라 그 이상은 어차피 반올림된다.
 *   화면을 2자리로 두면 대시보드(1.09km)와 서버에서 되읽은 값(1.1km)이 어긋난다.
 */
const KCAL_PER_STEP = 0.04;
const METER_PER_STEP = 0.8;

export const stepsToCalories = (steps) => Math.round(steps * KCAL_PER_STEP);

/** 표시용 문자열. "1.1" */
export const stepsToDistanceKm = (steps) =>
    ((steps * METER_PER_STEP) / 1000).toFixed(1);

/** 서버 전송용 숫자. walk_dstnc numeric(5,1) 에 그대로 들어간다. */
export const stepsToDistanceValue = (steps) =>
    Number(((steps * METER_PER_STEP) / 1000).toFixed(1));

/** 걸음수 0인 날은 "안 걸은 날"이 아니라 "기록이 없는 날"일 수 있어 평균에서 뺀다. */
export const averageSteps = (list) => {
    const walked = list.filter((d) => d.steps > 0);
    if (walked.length === 0) return 0;
    return Math.round(
        walked.reduce((sum, d) => sum + d.steps, 0) / walked.length,
    );
};
